import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { colors } from '@nw/shared/config';

import { SVGComponentProps } from '../type';

const EnrollmentBedIcon: React.FC<SVGComponentProps> = ({
  width = 20,
  height = 20,
  stroke = colors['light-blue-gray-600']
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path
        d="M2 4V20"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 8H20C21.1046 8 22 8.89543 22 10V20"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 8V17"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 17H18"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SVGUniqueID>
);

export { EnrollmentBedIcon };
